import { Box, Typography } from '@mui/material';
import { Page } from '../../shared/components/page';

export const AccessDeniedPage = () => (
  <Page className="access-denied-page">
    <Box sx={{ margin: 5 }}>
      <Typography variant="h3">Du har ikke tilgang til denne siden!</Typography>
      <Typography variant="subtitle1">Ta kontakt med IT-ansvarlig hvis du har behov for tilgang til denne siden.</Typography>
    </Box>
  </Page>
);
